// QuoteButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './QuoteButton.css';

const QuoteButton = ({ language }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(language === 'en' ? '/a' : '/orcamento'); // ou ajuste conforme sua rota real
  };

  return (
    <div className="quote-button-container">
      <button className="blinking-button" onClick={handleClick}>
        {language === 'en' ? 'Request a Quote' : 'Solicite um Orçamento'}
      </button>
    </div>
  );
};

export default QuoteButton;
